<template>
  <section class="section">
    <div class="container">
      <div class="columns is-centered">
        <div class="column is-narrow has-text-centered">
          <amplify-authenticator v-bind:authConfig="authConfig"></amplify-authenticator>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { AmplifyEventBus } from 'aws-amplify-vue';
import { Auth } from 'aws-amplify';

export default {
  name: 'SignIn',
  data: () => {
    return {
      authConfig: {
        signUpConfig: {
          hideAllDefaults: true,
          signUpFields: [
            {
              label: 'Email',
              key: 'email',
              required: true,
              displayOrder: 1,
              type: 'string',
              signUpWith: true
            },
            {
              label: 'Username',
              key: 'username',
              required: true,
              displayOrder: 2,
              type: 'string',
              signUpWith: true
            },
            {
              label: 'Password',
              key: 'password',
              required: true,
              displayOrder: 3,
              type: 'password'
            },
          ],
        },
      },
    };
  },
  methods: {
    handleAuth(info) {
      if (info === 'signedIn') {
        const path = this.$route.query.from || '/';
        this.$router.replace(path);
      }
    },
  },
  beforeCreate() {
    Auth.currentAuthenticatedUser().then(() => {
      const path = this.$route.query.from || '/';
      this.$router.replace(path);
    }).catch(() => {
      // This is fine that they are not auth'd
    });
  },
  mounted() {
    AmplifyEventBus.$on('authState', this.handleAuth);
  },
  beforeDestroy() {
    AmplifyEventBus.$off('authState', this.handleAuth);
  },
};
</script>
<style>
.error {
  color: rgb(224, 48, 48);
}
</style>